import React from "react";

export default function TermsAndConditions() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800">
      <h1 className="text-3xl font-bold text-[#264790] mb-8">Terms and Conditions</h1>

      <p className="mb-6">
        By visiting our site and/or purchasing something from us, you engage in our “Service” and agree to be bound by these Terms and Conditions
        (“Terms of Service”, “Terms”), including additional terms and policies referenced herein or available by hyperlink.
        These Terms apply to all users of the site.
      </p>

      {/* Repeatable Section Template */}
      {[
        {
          title: "SECTION 1 – ONLINE STORE TERMS",
          content: `By using this site, you confirm that you are at least the age of majority in your jurisdiction. You must not use our products for illegal purposes or violate any laws. Breach will result in termination of Services.`,
        },
        {
          title: "SECTION 2 – GENERAL CONDITIONS",
          content: `We reserve the right to refuse service to anyone. Your non-credit-card content may be transferred unencrypted. You agree not to reproduce or exploit the Service without written permission.`,
        },
        {
          title: "SECTION 3 – ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION",
          content: `We are not responsible if information on this site is inaccurate or outdated. Use the material at your own risk.`,
        },
        {
          title: "SECTION 4 – MODIFICATIONS TO THE SERVICE AND PRICES",
          content: `Prices may change without notice. We may modify or discontinue the Service at any time. We are not liable for such changes.`,
        },
        {
          title: "SECTION 5 – PRODUCTS OR SERVICES",
          content: `Certain products may be online-only and limited in quantity. Product descriptions and pricing may change anytime. We do not guarantee satisfaction or error correction.`,
        },
        {
          title: "SECTION 6 – ACCURACY OF BILLING AND ACCOUNT INFORMATION",
          content: `We may limit or cancel orders at our discretion. You agree to provide accurate and updated billing information. See our Return Policy for more.`,
        },
        {
          title: "SECTION 7 – OPTIONAL TOOLS",
          content: `Third-party tools are provided "as is". Use them at your own risk. We are not liable for their performance.`,
        },
        {
          title: "SECTION 8 – THIRD-PARTY LINKS",
          content: `We are not responsible for third-party content, products, or services. Review third-party policies before engaging.`,
        },
        {
          title: "SECTION 9 – USER COMMENTS, FEEDBACK AND SUBMISSIONS",
          content: `We may use your comments or feedback without restriction. You agree not to submit unlawful or misleading content.`,
        },
        {
          title: "SECTION 10 – PERSONAL INFORMATION",
          content: `Your personal data submission is governed by our Privacy Policy.`,
        },
        {
          title: "SECTION 11 – ERRORS, INACCURACIES AND OMISSIONS",
          content: `We reserve the right to correct errors or omissions and to cancel orders if any site content is inaccurate.`,
        },
        {
          title: "SECTION 12 – PROHIBITED USES",
          content: `You are prohibited from using the site for illegal or abusive activities. We reserve the right to terminate violators.`,
        },
        {
          title: "SECTION 13 – DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY",
          content: `We do not guarantee uninterrupted, error-free service. Your use of the Service is at your own risk. Our liability is limited to the maximum extent permitted by law.`,
        },
        {
          title: "SECTION 14 – INDEMNIFICATION",
          content: `You agree to indemnify and hold us harmless from claims related to your breach of these Terms.`,
        },
        {
          title: "SECTION 15 – SEVERABILITY",
          content: `If any part of these Terms is unenforceable, the remainder shall still apply.`,
        },
        {
          title: "SECTION 16 – TERMINATION",
          content: `These Terms remain in effect unless terminated by you or us. We may terminate your access at any time.`,
        },
        {
          title: "SECTION 17 – ENTIRE AGREEMENT",
          content: `These Terms constitute the entire agreement between you and us, superseding prior agreements.`,
        },
        {
          title: "SECTION 18 – GOVERNING LAW",
          content: `These Terms shall be governed by the laws of India and jurisdiction of Bangalore, Karnataka.`,
        },
        {
          title: "SECTION 19 – CHANGES TO TERMS OF SERVICE",
          content: `We may update these Terms at any time. Continued use of the site after changes implies acceptance.`,
        },
        {
          title: "SECTION 20 – CONTACT INFORMATION",
          content: `For any questions, contact us at: svalearn360@gmail.com.`,
        },
      ].map((section, idx) => (
        <div key={idx} className="mb-8">
          <h2 className="text-xl font-semibold text-[#264790] mb-2">{section.title}</h2>
          <p>{section.content}</p>
        </div>
      ))}
    </div>
  );
}
